/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, Typography, Box, MenuItem, Select, InputLabel, SelectChangeEvent, FormControl, Card, CardContent, TextField, useTheme, Checkbox, FormControlLabel, Snackbar, Alert, Paper, alpha, Grid, CircularProgress, Backdrop, Modal, Divider, Chip, IconButton } from '@mui/material';
import { AutoCompleteContaBancariaSimple, useVForm } from '../../../shared/forms';
import { FaturamentoService } from '../../../shared/services/api/Financeiro/Faturamento';
import * as yup from 'yup';
import { Environment } from '../../../shared/environment';
import ReceiptIcon from '@mui/icons-material/Receipt';
import CloseIcon from '@mui/icons-material/Close';
export type TipoPagamento = 1 | 2 | 3;
export type BandeiraCartao = 'visa' | 'mastercard' | 'elo' | 'hipercard' | 'american-express' | 'outros';
export type FormaPagamento = '90' | '03' | '04' | '17';

export interface IPagamentoData {
  id: string;
  idconta: string;
  idparceiro: string;
  indpag: number;
  tpag: string;
  tcnpj?: string;
  tband?: string;
  caut?: string;
  promocao: boolean;
}

export interface PaymentDialogProps {
  open: boolean;
  selectedtpag?: number;
  idpar: string | null;
  selectedId: string | null;
  numerodocumento?: number;
  valortotal?: number;
  parceironome?: string;
  emissaodata?: string;
  onClose: (value?: string) => void;
}

const pagamentoSchema = yup.object().shape({
  id: yup.string().required('O ID é obrigatório'),
  idparceiro: yup.string().required('O ID é obrigatório'),
  idconta: yup.string().required('Cadastre uma conta Padrão bancária'),
  indpag: yup.number().required('Informe o tipo de pagamento'),
  tpag: yup.string().required('Selecione a forma de pagamento'),
  tcnpj: yup.string().optional().default(''),
  tband: yup.string().optional().default('00'),
  caut: yup.string().optional().default('00'),
  promocao: yup.boolean().required(),
});

const FullScreenLoading: React.FC<{ message?: string; progress?: number }> = ({
  message = "Emitindo nota fiscal...",
  progress
}) => {
  return (
    <Backdrop
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 2,
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        display: 'flex',
        flexDirection: 'column',
        gap: 3
      }}
      open={true}
    >
      <CircularProgress
        size={60}
        sx={{
          color: 'white',
          '& .MuiCircularProgress-circle': {
            strokeLinecap: 'round',
          }
        }}
      />
      <Typography
        variant="h6"
        sx={{
          color: 'white',
          fontWeight: 500,
          textAlign: 'center'
        }}
      >
        {message}
      </Typography>
      {progress !== undefined && progress > 0 && (
        <Box sx={{ width: '300px', mt: 1 }}>
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              backgroundColor: 'rgba(255,255,255,0.2)',
              '& .MuiLinearProgress-bar': {
                backgroundColor: 'white'
              }
            }}
          />
          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)', mt: 0.5, display: 'block', textAlign: 'center' }}>
            {Math.round(progress)}%
          </Typography>
        </Box>
      )}
      <Typography
        variant="body2"
        sx={{
          color: 'rgba(255, 255, 255, 0.7)',
          textAlign: 'center'
        }}
      >
        Aguarde enquanto processamos sua solicitação...
      </Typography>
    </Backdrop>
  );
};
import { LinearProgress } from '@mui/material';

export const DialogNFE: React.FC<PaymentDialogProps> = (props: PaymentDialogProps) => {
  const { formRef } = useVForm();
  const { onClose, open, selectedId, idpar, numerodocumento, valortotal, parceironome, emissaodata, selectedtpag } = props;
  const [openmsg, setOpenmsg] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEmitting, setIsEmitting] = useState(false);
  const [msg, setMsg] = useState('');
  const [emittingProgress, setEmittingProgress] = useState(0);
  const [loadingMessage, setLoadingMessage] = useState('Emitindo nota fiscal...');

  const [idcontaError, setIdcontaError] = useState('');
  const [tms, setTms] = useState<'error' | 'success' | 'warning' | 'info'>('info');
  const theme = useTheme();

  const isDarkMode = theme.palette.mode === 'dark';

  useEffect(() => {
    setPagamento(prev => ({
      ...prev,
      id: selectedId || '',
      idparceiro: idpar || '',
    }));
  }, [selectedId, open, idpar]);

  useEffect(() => {
    if (!open) {
      resetStates();
    }
  }, [open]);

  const resetStates = () => {
    setOpenmsg(false);
    setMsg('');
    setTms('info');
    setIsEmitting(false);
    setIsLoading(false);
    setEmittingProgress(0);
    setLoadingMessage('Emitindo nota fiscal...');
    setPagamento({
      id: '',
      idparceiro: '',
      idconta: Environment.URL_IDCONTA || '',
      indpag: 0,
      tpag: '01',
      tband: '00',
      tcnpj: '',
      caut: '',
      promocao: false,
    });
  };

  const [pagamento, setPagamento] = useState<IPagamentoData>({
    id: selectedId || '',
    idparceiro: idpar || '',
    idconta: Environment.URL_IDCONTA || '',
    indpag: 0,
    tpag: '01',
    tband: '00',
    tcnpj: '',
    caut: '',
    promocao: false,
  });
  const todasFormasPagamento = [
    { id: '01', nome: 'Dinheiro' },
    { id: '17', nome: 'PIX Dinâmico' },
    { id: '20', nome: 'PIX Estático' },
    { id: '04', nome: 'Cartão de débito' },
    { id: '03', nome: 'Cartão de crédito' },
    { id: '90', nome: 'Sem pagamento' }
  ];

  const bandeirasCartao = [
    { id: '01', nome: 'Visa', cor: '#1a1f71', corLight: '#2a35a1' },
    { id: '02', nome: 'Mastercard', cor: '#eb001b', corLight: '#ff1a2e' },
    { id: '06', nome: 'Elo', cor: '#00a4e0', corLight: '#1ac4ff' },
    { id: '07', nome: 'Hipercard', cor: '#f47b00', corLight: '#ff9b2e' },
    { id: '03', nome: 'American Express', cor: '#2e77bc', corLight: '#4e97dc' },
    { id: '04', nome: 'Sorocred', cor: '#2e77bc', corLight: '#4e97dc' },
    { id: '05', nome: 'Diners Club', cor: '#2e77bc', corLight: '#4e97dc' },
    { id: '08', nome: 'Aura', cor: '#2e77bc', corLight: '#4e97dc' },
    { id: '09', nome: 'Cabal', cor: '#2e77bc', corLight: '#4e97dc' },
    { id: '99', nome: 'Outros', cor: '#666666', corLight: '#888888' }
  ];

  const simulateProgress = () => {
    setEmittingProgress(0);
    const interval = setInterval(() => {
      setEmittingProgress(prev => {
        if (prev >= 90) {
          clearInterval(interval);
          return 90;
        }
        return prev + 10;
      });
    }, 800);
    return interval;
  };

  const handleConfirmarPagamento = async (dadosPagamento: IPagamentoData) => {
    if (isEmitting || isLoading) {
      setTms('warning');
      setMsg('Aguarde, já existe uma emissão em andamento...');
      setOpenmsg(true);
      return;
    }

    try {
      const dadosValidados = await pagamentoSchema.validate(dadosPagamento, {
        abortEarly: false,
        stripUnknown: true,
      });

      if (!dadosValidados.id) return;

      const dadosCompletos: IPagamentoData = {
        ...dadosValidados,
      };

      setIsEmitting(true);
      setIsLoading(true);
      setLoadingMessage('Validando dados da nota fiscal...');

      const progressInterval = simulateProgress();

      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => reject(new Error('Tempo limite excedido. Tente novamente.')), 60000);
      });
      const servicePromise = FaturamentoService.createnfe(dadosCompletos);
      const resultado = await Promise.race([servicePromise, timeoutPromise]);

      clearInterval(progressInterval);
      setEmittingProgress(100);
      setLoadingMessage('Nota emitida com sucesso!');

      if (typeof resultado === 'string' && resultado.startsWith('JVBERi0x')) {
        const dataUrl = `data:application/pdf;base64,${resultado}`;
        const novaAba = window.open(dataUrl, '_blank');
        if (!novaAba) {
          setTms('error');
          setMsg('Permita pop-ups para visualizar a NFe');
          setIsEmitting(false);
          setIsLoading(false);
          return;
        }
        setTms('success');
        setMsg('NFe gerada com sucesso!');
        setTimeout(() => {
          setIsEmitting(false);
          setIsLoading(false);
          onClose();
        }, 1500);
      }
      else if (resultado instanceof Blob) {
        const url = URL.createObjectURL(resultado);
        const novaAba = window.open(url, '_blank');
        if (!novaAba) {
          setTms('error');
          setMsg('Permita pop-ups para visualizar a NFe');
          setIsEmitting(false);
          setIsLoading(false);
          return;
        }
        setTms('success');
        setMsg('NFe gerada com sucesso!');
        setTimeout(() => {
          URL.revokeObjectURL(url);
          setIsEmitting(false);
          setIsLoading(false);
          onClose();
        }, 1500);
      }
      else if (resultado instanceof Error) {
        setTms('error');
        setMsg(resultado.message || 'Erro ao gerar NFe');
        setIsEmitting(false);
        setIsLoading(false);
      }
      else {
        setTms('error');
        setMsg('Resposta inesperada do servidor');
        setIsEmitting(false);
        setIsLoading(false);
      }
    } catch (error: unknown) {
      console.error('Erro na emissão:', error);
      setIsEmitting(false);
      setIsLoading(false);

      if (error instanceof Error) {
        if (error.message === 'Tempo limite excedido. Tente novamente.') {
          setTms('error');
          setMsg('A emissão está demorando mais que o esperado. Verifique sua conexão e tente novamente.');
        } else {
          setTms('error');
          setMsg(error.message || 'Erro ao gerar NFe');
        }
      } else if (error && typeof error === 'object' && 'name' in error && error.name === 'ValidationError') {
        const validationError = error as { errors?: string[] };
        setTms('error');
        setMsg(validationError.errors?.join('\n') || 'Erro de validação');
      } else {
        setTms('error');
        setMsg('Erro inesperado ao gerar NFe. Tente novamente.');
      }
    } finally {
      setOpenmsg(true);
    }
  };

  const handleCancel = () => {
    if (isEmitting) {
      setTms('warning');
      setMsg('Aguarde a conclusão da emissão antes de cancelar.');
      setOpenmsg(true);
      return;
    }
    resetStates();
    onClose();
  };


  const handleFormaPagamentoChange = (event: SelectChangeEvent<string>) => {
    if (isEmitting) return;
    const novaForma = event.target.value;

    const novoPagamento: IPagamentoData = {
      ...pagamento,
      tpag: novaForma,
      promocao: novaForma === '01' ? pagamento.promocao : false,
    };
    setPagamento(novoPagamento);
    formRef.current?.setData(novoPagamento);
  };

  const handleBandeiraChange = (event: SelectChangeEvent<string>) => {
    if (isEmitting) return;
    const novoPagamento: IPagamentoData = {
      ...pagamento,
      tband: event.target.value
    };
    setPagamento(novoPagamento);
    formRef.current?.setData(novoPagamento);
  };

  const handleCodigoTransacaoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (isEmitting) return;
    const novoPagamento: IPagamentoData = {
      ...pagamento,
      caut: event.target.value
    };
    setPagamento(novoPagamento);
    formRef.current?.setData(novoPagamento);
  };

  const isPagamentoCartao = pagamento.tpag === '03' || pagamento.tpag === '04';

  // Função para formatar valor monetário
  const formatCurrency = (value?: number) => {
    if (!value && value !== 0) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  // Função para formatar data
  const formatDate = (dateString?: string) => {
    if (!dateString) return '—';
    try {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(date);
    } catch {
      return dateString;
    }
  };

  return (
    <>
      {isEmitting && (
        <FullScreenLoading
          message={loadingMessage}
          progress={emittingProgress}
        />
      )}

      <Snackbar
        open={openmsg}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={6000}
        onClose={() => setOpenmsg(false)}
      >
        <Alert
          severity={tms}
          onClose={() => setOpenmsg(false)}
          variant="filled"
          sx={{
            width: '100%',
            maxWidth: 500,
            borderRadius: 2,
            boxShadow: theme.shadows[3]
          }}
        >
          {msg}
        </Alert>
      </Snackbar>

      <Dialog
        open={open}
        onClose={handleCancel}
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: theme.shadows[10],
            maxWidth: '480px',
            width: '90vw',
            margin: 2,
            overflow: 'hidden',
            bgcolor: 'background.paper'
          }
        }}
      >
        <Box
          sx={{
            p: 2.5,
            pb: 1.5,
            borderBottom: `1px solid ${theme.palette.divider}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            bgcolor: 'background.paper'
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: 2,
                bgcolor: alpha(theme.palette.primary.main, 0.1),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: theme.palette.primary.main
              }}
            >
              <ReceiptIcon />
            </Box>
            <Box>
              <Typography variant="h6" fontWeight="700" sx={{ lineHeight: 1.2 }}>
                Emitir NFe
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Nota Fiscal Eletrônica
              </Typography>
            </Box>
          </Box>
          <IconButton
            onClick={handleCancel}
            disabled={isEmitting}
            size="small"
            sx={{
              color: theme.palette.text.secondary,
              '&:hover': {
                bgcolor: alpha(theme.palette.text.primary, 0.05)
              }
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Box
          sx={{
            p: 2,
            borderBottom: `1px solid ${theme.palette.divider}`,
            bgcolor: isDarkMode ? alpha(theme.palette.background.default, 0.4) : theme.palette.grey[50]
          }}
        >
          <Grid container spacing={1.5}>
            <Grid item xs={5}>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem' }}>
                Nº Documento
              </Typography>
              <Typography variant="body2" fontWeight="600">
                #{numerodocumento || '—'}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem' }}>
                Data Emissão
              </Typography>
              <Typography variant="body2" fontWeight="500" sx={{ fontSize: '0.75rem' }}>
                {formatDate(emissaodata)}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem' }}>
                Total
              </Typography>
              <Typography variant="body2" fontWeight="700" color="success.main" sx={{ fontSize: '0.85rem' }}>
                {formatCurrency(valortotal)}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem' }}>
                Cliente
              </Typography>
              <Typography
                variant="body2"
                fontWeight="500"
                sx={{
                  fontSize: '0.8rem',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
              >
                {parceironome || '—'}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <DialogContent dividers sx={{ p: 0 }}>
          <Card sx={{
            border: 'none',
            boxShadow: 'none',
            bgcolor: 'background.paper'
          }}>
            <CardContent sx={{ p: 3 }}>
              <FormControl fullWidth sx={{ mb: 2 }} variant="outlined">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={pagamento.promocao}
                      onChange={(e) =>
                        setPagamento({ ...pagamento, promocao: e.target.checked })
                      }
                      color="primary"
                      disabled={pagamento.tpag !== '01'}
                    />
                  }
                  label="Aplicar promoção"
                  sx={{
                    mb: 1,
                    '& .MuiTypography-root': {
                      color: 'text.primary',
                      fontWeight: 500
                    }
                  }}
                />
              </FormControl>

              <FormControl fullWidth sx={{ mb: 3 }} variant="outlined">
                <InputLabel
                  id="forma-pagamento-label"
                  sx={{
                    fontWeight: 600,
                    backgroundColor: theme.palette.background.paper,
                    px: 0.5,
                  }}
                >
                  Forma de Pagamento
                </InputLabel>
                <Select
                  labelId="forma-pagamento-label"
                  value={pagamento.tpag}
                  onChange={handleFormaPagamentoChange}
                  label="Forma de Pagamento"
                  disabled={isEmitting}
                  sx={{
                    borderRadius: 2,
                    '& .MuiSelect-select': {
                      py: 1.5
                    },
                    '&.MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: theme.palette.divider,
                      },
                      '&:hover fieldset': {
                        borderColor: theme.palette.primary.main,
                      },
                    }
                  }}
                >
                  {todasFormasPagamento.map((forma) => (
                    <MenuItem key={forma.id} value={forma.id}>
                      {forma.nome}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {selectedtpag === 1 && (
                <Grid container spacing={1} sx={{ mb: 2 }}>
                  <Grid item xs={12}>
                    <AutoCompleteContaBancariaSimple
                      label='Conta'
                      value={pagamento.idconta}
                      onChange={(idconta) => {
                        setPagamento({ ...pagamento, idconta });
                        setIdcontaError('');
                      }}
                      isExternalLoading={isLoading}
                      disabled={isEmitting}
                      error={!!idcontaError}
                      helperText={idcontaError}
                    />
                  </Grid>
                </Grid>
              )}
              {isPagamentoCartao && (
                <>
                  <FormControl fullWidth sx={{ mb: 3 }} variant="outlined">
                    <InputLabel
                      id="bandeira-label"
                      sx={{
                        fontWeight: 600,
                        backgroundColor: theme.palette.background.paper,
                        px: 0.5,
                      }}
                    >
                      Bandeira do Cartão
                    </InputLabel>
                    <Select
                      labelId="bandeira-label"
                      value={pagamento.tband || ''}
                      onChange={handleBandeiraChange}
                      label="Bandeira do Cartão"
                      disabled={isEmitting}
                      sx={{
                        borderRadius: 2,
                        '& .MuiSelect-select': {
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          py: 1.5
                        }
                      }}
                    >
                      {bandeirasCartao.map((bandeira) => (
                        <MenuItem key={bandeira.id} value={bandeira.id} sx={{ gap: 2 }}>
                          <Box
                            sx={{
                              width: 24,
                              height: 24,
                              borderRadius: '50%',
                              backgroundColor: isDarkMode ? bandeira.corLight : bandeira.cor,
                              boxShadow: theme.shadows[1],
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '12px',
                              color: 'white'
                            }}
                          />
                          <span>{bandeira.nome}</span>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <TextField
                    fullWidth
                    label="Código da Transação"
                    value={pagamento.caut || ''}
                    onChange={handleCodigoTransacaoChange}
                    disabled={isEmitting}
                    sx={{ mb: 3 }}
                    variant="outlined"
                    placeholder="Digite o código da transação"
                    InputLabelProps={{
                      sx: {
                        fontWeight: 500
                      }
                    }}
                  />
                </>
              )}
            </CardContent>
          </Card>
        </DialogContent>

        <DialogActions sx={{
          p: 3,
          gap: 2,
          bgcolor: theme.palette.background.default,
          borderTop: `1px solid ${theme.palette.divider}`
        }}>
          <Button
            variant="outlined"
            onClick={handleCancel}
            disabled={isEmitting}
            sx={{
              borderRadius: 2,
              px: 3,
              py: 1,
              textTransform: 'none',
              fontWeight: 600,
              borderWidth: 2,
              '&:hover': {
                borderWidth: 2,
                bgcolor: alpha(theme.palette.text.primary, 0.05)
              }
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            autoFocus
            onClick={() => handleConfirmarPagamento(pagamento)}
            disabled={isEmitting || isLoading}
            sx={{
              borderRadius: 2,
              px: 3,
              py: 1,
              textTransform: 'none',
              fontWeight: 600,
              background: isDarkMode
                ? `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`
                : `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              '&:hover': {
                transform: 'translateY(-1px)',
                boxShadow: theme.shadows[4],
                background: isDarkMode
                  ? `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`
                  : `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`
              },
              transition: 'all 0.2s ease',
              '&.Mui-disabled': {
                background: theme.palette.action.disabledBackground,
                transform: 'none'
              }
            }}
          >
            {isEmitting ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CircularProgress size={20} color="inherit" />
                <span>Emitindo...</span>
              </Box>
            ) : (
              'Confirmar Pagamento'
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};